import { api } from './configs/axiosConfig';
export const SettingsAPI = {
    getSettings: async function () {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/config/theme`);
        return response?.data;
    },
    putSettings: async function (data, id) {
        const response = await api.put(`${process.env.REACT_APP_API_URL}/config/${id}`, data);
        return response?.data;
    },
    getSettingsImage: async function (type, imageType) {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/config/${type}/image?image_type=${imageType}`);
        return response?.data;
    },
    patchSettingsImage: async function (data, id) {
        const response = await api.patch(`${process.env.REACT_APP_API_URL}/config/${id}/image`, data);
        return response?.data;
    }
};
